import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import setupAxiosInterceptors from "../AxiosInterceptor";

const AxiosInterceptorSetup = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    setupAxiosInterceptors(navigate);
  }, []);

  return children;
};

export default AxiosInterceptorSetup;